import classNames from "classnames";
import styles from "./AscDateCard.module.scss";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { CalendarEmptyIcon } from "../../AscIcons";
dayjs.extend(relativeTime);

export interface AscFiltersCardProps {
  className?: string;
  loading?: boolean;
  date?: string;
}

export default function AscDateCard({
  className,
  loading,
  date,
}: AscFiltersCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      contentClassName={styles.cardContent}
      title="Date"
      coverImageUrl={null}
      loading={loading}
    >
      <CalendarEmptyIcon className={styles.calendarIcon} />
      <span className={styles.time}>{dayjs(date).format("D MMM[,] YYYY")}</span>
    </AscGenericCard>
  );
}
